module.exports = __webpack_public_path__ + "static/media/Icon-Calendar.de1de72a.svg";